import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-ribbon',
    templateUrl: './ribbon.component.html',
    styleUrls: ['./ribbon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RibbonComponent {
    @Input() label: string;
}
